<template>
    <TxProductSettingsPortal>
        <TxSettingsUi>
            <div title="1. Design">
                <div>
                    <LoveMapToggle
                            v-model="mapSize"
                            label="Välj storlek"
                            :options="sizeOptions"
                    />
                </div>
                <div>
                    <LoveMapToggle
                            v-model="mapLayout"
                            label="Format"
                            :options="layoutOptions"
                    />
                </div>
                <div>
                    <LoveMapToggle
                            v-model="textStyle"
                            label="Stil på text"
                            :options="textStyles"
                    />
                </div>

                <TxCkeEditor
                        v-model="mainText"
                        label="Din egen text"
                />

                <love-map-input
                        v-model="authorText"
                        placeholder="Namn på den som sa det"
                        label="Upphovsmakare / person som sa det (frivilligt)"
                />

            </div>
            <div title="2. Ram" v-if="$root.env === 'frontend'">
                <love-map-select v-model="selectedRam" label="Ram" :options="ramOptions"/>
            </div>
        </TxSettingsUi>
        <love-map-description>
            Glöm inte dubbelkolla så att din poster ser ut som du vill ha den, den går inte att ändra i efterhand.
        </love-map-description>
    </TxProductSettingsPortal>
</template>

<script>
    import debounce from 'lodash/debounce'

    import mapPresets from "./data/mapPresets";

    import ramMapping from "./data/ramMapping.json"
    import PosterTextModule from "@packages/tx-products/products/poster-text/store-mixin";

    import useSaveUrlMixin from "@packages/tx-mixins/mixins/saveUrl.mixin"

    import templateOptions from "./data/templateOptions";

    export default {
        name: 'PosterTextSettings',
        mixins: [PosterTextModule(), useSaveUrlMixin('poster-text')],
        watch: {
            mapSize:{
              handler: function (newValue, oldValue) {
                this.mapSizeChanged(newValue);
                this.initRamField(newValue)
              },
              immediate: true
            },
            selectedRam(newValue, oldValue) {
                this.ramChanged(newValue);
            },
        },
        data() {
            return {
                ramOptions: [],
                preset: null,
                selectedRam: null,
                selected1: null,
                cityOptions1: [],
                ...templateOptions,
            }
        },
        mounted() {
            this.$nextTick(() => {
                if (!this.mapSize) {
                    this.mapSize = 'a4';
                    this.mapSizeChanged();
                }

                setTimeout(()=>{
                    this.initRamField();
                },2000)
            })
        },
        computed: {
            geoAPI() {
                return lovemap?.config?.geoAPI
            },
            enableGeoAPI() {
                return !!this.geoAPI
            },
            searchUrl() {
                if (this.enableGeoAPI) {
                    return 'https://maps.googleapis.com/maps/api/geocode/json'
                } else {
                    return 'https://nominatim.openstreetmap.org/search'
                }
            },
        },
        methods: {
            getRamSelector() {
                let {fieldSelector} = ramMapping[this.mapSize]
                return fieldSelector
            },
            initRamField(value) {
                let fieldSelector = this.getRamSelector();
                console.log(fieldSelector);
                if (jQuery) {
                    jQuery(".variations_form.cart").arrive(fieldSelector, () => {
                        this.$set(this, 'ramOptions', this.getSelectArray(fieldSelector))
                        this.selectedRam = 'ingen_ram';
                    });
                }
            },
            getSelectArray(selector) {
                if (selector) {
                    let array = [];
                    jQuery(selector).find('option').each(function (i, o) {
                        let item = {};
                        item.label = jQuery(o).text();
                        item.value = jQuery(o).val();
                        array.push(item);
                    });
                    return array
                }
                return [];
            },
            presetChanged(value) {
                this.setPreset(value);
            },
            setObjectData(object) {
                this.$nextTick(() => {
                    if (object) {
                        Object.keys(object).map(key => {
                            if (key !== 'mapBounds') {
                              console.log(key, object[key])
                                this.$set(this, key, object[key]);
                            }
                            if (key === 'mainText'){
                              setTimeout(()=>{
                                this.$set(this, key, object[key]);
                              },1500)
                            }
                        });
                        this.$forceUpdate();
                    }
                })
            },
            setPreset(value) {
                this.presetSelected = true;
                this.$nextTick(() => {
                    let preset = mapPresets[value];
                    if (preset) {
                        Object.keys(preset).map(key => {
                            this.$set(this, key, preset[key]);
                        })
                    }
                    setTimeout(() => {
                        this.presetSelected = false;
                    }, 500)
                })

            },
            searchObject(search) {
                if (this.enableGeoAPI) {
                    return {
                        key: this.geoAPI,
                        address: search,
                        language: 'sv'
                    }
                } else {
                    return {
                        format: 'json',
                        city: search
                    }
                }
            },
            saveSearch(key, data) {
                if (this.enableGeoAPI) {
                    let {results, status} = data
                    if (status) {
                        this.$set(this, key, results);
                    }

                } else {
                    this.$set(this, key, data);
                }
            },
            onsearch(e) {
                if (e.target.value) {
                    this.listFinded = this.list.filter(el => el.text.indexOf(e.target.value) !== -1 || el.address.indexOf(e.target.value) !== -1);
                } else {
                    this.listFinded = this.list;
                }
            },
            fetchOptions(event) {
                this.search(event.target.value, this);
            },
            fetchOptions2(event) {
                this.search2(event.target.value, this);
            },
            search: debounce((search, vm) => {
                let http = vm.$root.env === 'admin' ? vm.$httpExternal : vm.$http;
                http({
                    method: 'get',
                    url: vm.searchUrl,
                    params: vm.searchObject(search)
                }).then(({data}) => {
                    vm.saveSearch('cityOptions1', data);
                });
            }, 350),
            search2: debounce((search, vm) => {
                let http = vm.$root.env === 'admin' ? vm.$httpExternal : vm.$http;
                http({
                    method: 'get',
                    url: vm.searchUrl,
                    params: vm.searchObject(search)
                }).then(({data}) => {
                    vm.saveSearch('cityOptions2', data);
                });
            }, 350),
            mapSizeChanged(value) {
              console.log(value)
                if (jQuery && jQuery('[name="attribute_pa_storlek"]').length) {
                    jQuery('[name="attribute_pa_storlek"]').val(value).change();
                }
            },
            ramChanged(value) {
                let selector = this.getRamSelector();
                console.log(selector)
                if (jQuery && jQuery(selector).length) {
                    jQuery(selector).val(value).change();
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .stad-label {
        margin-bottom: -5px;
    }

    ::v-deep .coordinates-input {
        width: 100%;
        margin: 0 auto 15px;
        height: 39px;

        & * {
            font-size: 0.875rem !important;
            font-weight: normal !important;
        }

        .stf-select__inner-wrapper {
            display: block;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            width: 100%;
            padding: 0 0.5rem;
            border: 1px solid rgba(41, 41, 41, 0.1);
            border-radius: 0;
            font-family: inherit;
            line-height: 1.5;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            color: #444;
            background-color: #fff;
            height: 2.5rem;
            outline: none;
            font-weight: 900;
            margin: 0;
        }

        .stf-select__search-input input {
            height: 39px;
        }

        .stf-select__placeholder {
            line-height: 39px;
            color: #cacaca;
        }

        &.stf-select_opened {
            .stf-select__inner-wrapper {
                border: none;
            }

            .stf-select__search-input input {
                outline-width: 0;
                color: #444;
                border: 1px solid rgba(41, 41, 41, 0.15) !important;
                background: #fafafa;
            }
        }
    }
</style>

<style lang="scss">
    #wccf_product_field_master_container {
        display: none;
    }

    table.variations {
        display: none;
    }
</style>

